/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * GameEventBase
 * auto generated base class for the model GameEventModel.
 */
export const GameEventModelBase = ModelBase.named('GameEvent')
  .props({
    __typename: types.optional(types.literal('GameEvent'), 'GameEvent'),
    _id: types.identifier,
    chipsWon: types.union(types.undefined, types.number),
    createdAt: types.union(types.undefined, types.frozen()),
    eventId: types.union(types.undefined, types.string),
    gameId: types.union(types.undefined, types.frozen()),
    kind: types.union(types.undefined, types.string),
    payload: types.union(types.undefined, types.frozen()),
    rankedHandIndex: types.union(types.undefined, types.number),
    rankedHandName: types.union(types.undefined, types.string),
    updatedAt: types.union(types.undefined, types.frozen()),
    userId: types.union(types.undefined, types.frozen()),
    users: types.union(types.undefined, types.array(types.string)),
    winners: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class GameEventModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get chipsWon() {
    return this.__attr('chipsWon')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get eventId() {
    return this.__attr('eventId')
  }
  get gameId() {
    return this.__attr('gameId')
  }
  get kind() {
    return this.__attr('kind')
  }
  get payload() {
    return this.__attr('payload')
  }
  get rankedHandIndex() {
    return this.__attr('rankedHandIndex')
  }
  get rankedHandName() {
    return this.__attr('rankedHandName')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get userId() {
    return this.__attr('userId')
  }
  get users() {
    return this.__attr('users')
  }
  get winners() {
    return this.__attr('winners')
  }
}
export function selectFromGameEvent() {
  return new GameEventModelSelector()
}

export const gameEventModelPrimitives =
  selectFromGameEvent()._id.chipsWon.createdAt.eventId.gameId.kind.payload.rankedHandIndex.rankedHandName.updatedAt
    .userId.users.winners
